import { calculateAge } from '../../utils/ageCalculator';

/**
 * Normaliza el código de sexo al valor numérico (INT) de dbo.elementosisa:
 * 1 = MASCULINO, 2 = FEMENINO, 3 = INDETERMINADO
 */
export const normalizePaiSexo = (val) => {
  if (val === null || val === undefined || val === '') return '';
  const clean = String(val).trim().toUpperCase();
  if (['M', 'MASCULINO', 'HOMBRE', '1'].includes(clean)) return 1;
  if (['F', 'FEMENINO', 'MUJER', '2'].includes(clean)) return 2;
  if (['I', 'INDETERMINADO', '3'].includes(clean)) return 3;
  return !Number.isNaN(Number(clean)) ? Number(clean) : clean;
};

/**
 * Normaliza el género al valor numérico (INT) de dbo.elementosisa:
 * 1 = MASCULINO, 2 = FEMENINO, 3 = NO APLICA
 */
export const normalizePaiGenero = (val) => {
  if (val === null || val === undefined || val === '') return '';
  const clean = String(val).trim().toUpperCase();
  if (['M', 'MASCULINO', 'HOMBRE', '1'].includes(clean)) return 1;
  if (['F', 'FEMENINO', 'MUJER', '2'].includes(clean)) return 2;
  if (['NO APLICA', 'NA', 'N/A', '3'].includes(clean)) return 3;
  return !Number.isNaN(Number(clean)) ? Number(clean) : clean;
};

/**
 * Normaliza la orientación sexual al valor numérico (INT) de dbo.elementosisa:
 * 1 = NO APLICA, 2 = HETEROSEXUAL, 3 = HOMOSEXUAL, 4 = BISEXUAL
 */
export const normalizePaiOrientacion = (val) => {
  if (val === null || val === undefined || val === '') return '';
  const clean = String(val).trim().toUpperCase();
  if (['NO APLICA', 'NA', 'N/A', '1'].includes(clean)) return 1;
  if (['HETEROSEXUAL', 'HETERO', '2'].includes(clean)) return 2;
  if (['HOMOSEXUAL', 'HOMO', 'GAY', 'LESBIANA', '3'].includes(clean)) return 3;
  if (['BISEXUAL', 'BI', '4'].includes(clean)) return 4;
  return !Number.isNaN(Number(clean)) ? Number(clean) : clean;
};

/**
 * Normaliza el código de régimen de afiliación al valor numérico (INT) de dbo.elementosisa:
 * 1 = CONTRIBUTIVO, 2 = SUBSIDIADO, 3 = ESPECIAL, 4 = VINCULADO, 5 = OTRO
 */
export const normalizePaiRegimen = (val) => {
  if (val === null || val === undefined || val === '') return '';
  const clean = String(val).trim().toUpperCase();
  if (['C', 'CONTRIBUTIVO', '1'].includes(clean)) return 1;
  if (['S', 'SUBSIDIADO', '2'].includes(clean)) return 2;
  if (['E', 'P', 'ESPECIAL', '3'].includes(clean)) return 3;
  if (['V', 'VINCULADO', '4'].includes(clean)) return 4;
  if (['O', 'OTRO', '5'].includes(clean)) return 5;
  return !Number.isNaN(Number(clean)) ? Number(clean) : clean;
};

/**
 * Normaliza el código de área al valor numérico (INT) de dbo.elementosisa:
 * 1 = U - URBANA, 2 = R - RURAL
 */
export const normalizePaiArea = (val) => {
  if (val === null || val === undefined || val === '') return '';
  const clean = String(val).trim().toUpperCase();
  if (['U', 'URBANA', 'U - URBANA', 'U -URBANA', '1'].includes(clean)) return 1;
  if (['R', 'RURAL', 'R - RURAL', 'R -RURAL', '2'].includes(clean)) return 2;
  return !Number.isNaN(Number(clean)) ? Number(clean) : clean;
};

/**
 * Normaliza campos Sí/No al valor numérico (INT) de dbo.elementosisa:
 * 1 = SI, 2 = NO
 */
export const normalizePaiSiNo = (val) => {
  if (val === null || val === undefined || val === '') return '';
  const clean = String(val).trim().toUpperCase();
  if (['SI', 'S', '1', 'TRUE'].includes(clean)) return 1;
  if (['NO', 'N', '2', 'FALSE', '0'].includes(clean)) return 2;
  return !Number.isNaN(Number(clean)) ? Number(clean) : clean;
};

/**
 * Normaliza la condición de la usuaria al valor numérico (INT) de dbo.elementosisa:
 * 1 = GESTANTES, 2 = MUJER EN EDAD FERTIL (MEF), 3 = POR CONTACTO (HANSEN), 4 = VIAJERO
 */
export const normalizePaiCondicion = (val) => {
  if (val === null || val === undefined || val === '') return '';
  const clean = String(val).trim().toUpperCase();
  if (['GESTANTES', 'GESTANTE', '1'].includes(clean)) return 1;
  if (['MUJER EN EDAD FERTIL (MEF)', 'MEF', '2'].includes(clean)) return 2;
  if (['POR CONTACTO (HANSEN)', 'HANSEN', '3'].includes(clean)) return 3;
  if (['VIAJERO', '4'].includes(clean)) return 4;
  return !Number.isNaN(Number(clean)) ? Number(clean) : clean;
};

/**
 * Normaliza el tipo de carnet al valor numérico (INT) de dbo.elementosisa (1 a 6).
 */
export const normalizePaiTipoCarnet = (val) => {
  if (val === null || val === undefined || val === '') return '';
  const clean = String(val).trim().toUpperCase();
  if (clean.includes('INFANTIL') || clean === '1') return 1;
  if ((clean.includes('ADULTO') && clean.includes('CERTIFICADO')) || clean === '2') return 2;
  if (clean.includes('INTERNACIONAL') || clean === '3') return 3;
  if (clean.includes('TUV ADULTOS') || clean === '4') return 4;
  if (clean.includes('TUV') || clean === '5') return 5;
  if (clean.includes('COVID') || clean === '6') return 6;
  return !Number.isNaN(Number(clean)) ? Number(clean) : clean;
};

/**
 * Normaliza el código de país al valor numérico (INT) de dbo.elementosisa (form = 'general', label = 'pais'):
 * 1 = COLOMBIA, 2 = VENEZUELA, 3 = ECUADOR, ...
 */
export const normalizePaiPais = (val) => {
  if (val === null || val === undefined || val === '') return '';
  const clean = String(val).trim().toUpperCase();
  if (['COLOMBIA', 'COLMBIA', 'COL', 'CO', '1'].includes(clean)) return 1;
  if (['VENEZUELA', 'VEN', 'VE', '2'].includes(clean)) return 2;
  if (['ECUADOR', 'EC', '3'].includes(clean)) return 3;
  if (['PERU', 'PERÚ', 'PE', '4'].includes(clean)) return 4;
  if (['BRASIL', 'BRAZIL', 'BR', '5'].includes(clean)) return 5;
  if (['BOLIVIA', 'BO', '6'].includes(clean)) return 6;
  if (['CHILE', 'CL', '7'].includes(clean)) return 7;
  if (['ARGENTINA', 'AR', '8'].includes(clean)) return 8;
  if (['PANAMA', 'PANAMÁ', 'PA', '9'].includes(clean)) return 9;
  if (['ESTADOS UNIDOS', 'EEUU', 'USA', 'US', '10'].includes(clean)) return 10;
  if (['ESPANA', 'ESPAÑA', 'ES', '11'].includes(clean)) return 11;
  if (['MEXICO', 'MÉXICO', 'MX', '12'].includes(clean)) return 12;
  if (['PARAGUAY', 'PY', '13'].includes(clean)) return 13;
  if (['URUGUAY', 'UY', '14'].includes(clean)) return 14;
  if (['COSTA RICA', 'CR', '15'].includes(clean)) return 15;
  if (['CUBA', 'CU', '16'].includes(clean)) return 16;
  if (['REPUBLICA DOMINICANA', 'REPÚBLICA DOMINICANA', 'DOMINICANA', 'DO', '17'].includes(clean)) return 17;
  if (['HAITI', 'HAITÍ', 'HT', '18'].includes(clean)) return 18;
  if (['GUATEMALA', 'GT', '19'].includes(clean)) return 19;
  if (['HONDURAS', 'HN', '20'].includes(clean)) return 20;
  if (['EL SALVADOR', 'SV', '21'].includes(clean)) return 21;
  if (['NICARAGUA', 'NI', '22'].includes(clean)) return 22;
  if (['CANADA', 'CANADÁ', 'CA', '23'].includes(clean)) return 23;
  if (['OTRO', 'OTROS', '24'].includes(clean)) return 24;
  return !Number.isNaN(Number(clean)) ? Number(clean) : clean;
};

/**
 * Normaliza la pertenencia étnica al valor numérico (INT) de dbo.elementosisa:
 * 1 = INDÍGENA, 2 = ROM (GITANO), 3 = RAIZAL, 4 = PALENQUERO, 5 = NEGRO, MULATO O AFRODESCENDIENTE, 6 = NINGUNA DE LAS ANTERIORES
 */
export const normalizePaiEtnia = (val) => {
  if (val === null || val === undefined || val === '') return '';
  const clean = String(val).trim().toUpperCase();
  if (clean === '1' || clean.includes('INDIG')) return 1;
  if (clean === '2' || clean.includes('ROM') || clean.includes('GITAN')) return 2;
  if (clean === '3' || clean.includes('RAIZAL')) return 3;
  if (clean === '4' || clean.includes('PALENQU')) return 4;
  if (clean === '5' || clean.includes('NEGR') || clean.includes('MULAT') || clean.includes('AFRO')) return 5;
  if (clean === '6' || clean.includes('NINGUN') || clean.includes('NO APLICA') || ['NA', 'N/A', 'NO', 'OTRO'].includes(clean)) return 6;
  return !Number.isNaN(Number(clean)) ? Number(clean) : clean;
};

/**
 * Evalúa si la sección "Condición de la Usuaria" debe estar bloqueada
 * según el sexo y la edad del paciente:
 * - Bloqueada en Hombres (sexo = 1 / '1' / 'MASCULINO' / 'M').
 * - Bloqueada en Mujeres menores de 10 años (< 10) o mayores de 55 años (> 55).
 */
export const getCondicionUsuariaBlockStatus = (patientInfo = {}) => {
  const rawSexo = normalizePaiSexo(patientInfo.sexo);
  const isMale = rawSexo === 1 || rawSexo === '1' || rawSexo === 'MASCULINO';

  if (isMale) {
    return {
      blocked: true,
      reason: 'Bloqueado: No aplica para hombres.'
    };
  }

  let ageYears = patientInfo.edad_anios;
  if ((ageYears === undefined || ageYears === null || ageYears === '') && patientInfo.fecha_nacimiento) {
    const calc = calculateAge(patientInfo.fecha_nacimiento);
    ageYears = calc.years;
  }

  const parsedAge = ageYears !== undefined && ageYears !== null && ageYears !== '' ? Number(ageYears) : NaN;

  if (!Number.isNaN(parsedAge) && (parsedAge < 10 || parsedAge > 55)) {
    return {
      blocked: true,
      reason: 'Bloqueado: Solo aplica para mujeres entre 10 y 55 años.'
    };
  }

  return {
    blocked: false,
    reason: ''
  };
};

export const isCondicionUsuariaBlocked = (patientInfo = {}) => {
  return getCondicionUsuariaBlockStatus(patientInfo).blocked;
};

/**
 * Mapea los datos del paciente y madre provenientes de la API 
 * al formato esperado por el estado del formulario (formData).
 */
export const mapApiPatientToForm = (resData, patientDataSections, currentFormData = {}) => {
  const { pacientes, tutores_madre, vacunas } = resData;
  const updates = {};

  const findSecIdx = (keyword) => patientDataSections.findIndex(s => {
    const normName = s.name.toUpperCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    const normKey = keyword.toUpperCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    return normName.includes(normKey);
  });

  const basicosIdx = findSecIdx('BASICOS');
  const compIdx = findSecIdx('COMPLEMENTARIOS');
  const madreIdx = findSecIdx('MADRE');
  const esquemaIdx = findSecIdx('ESQUEMA');

  const getSecId = (idx) => idx >= 0 ? patientDataSections[idx].id : null;
  const sBasicos = getSecId(basicosIdx);
  const sComp = getSecId(compIdx);
  const sMadre = getSecId(madreIdx);
  const sEsquema = getSecId(esquemaIdx);

  if (pacientes) {
    let calcYears = pacientes.edad_anios;
    let calcMonths = pacientes.edad_meses;
    let calcDays = pacientes.edad_dias;
    let calcTotalMonths = pacientes.total_meses;

    if (pacientes.fecha_nacimiento && (calcYears === undefined || calcYears === null || calcYears === '')) {
      const mathCalc = calculateAge(pacientes.fecha_nacimiento);
      calcYears = mathCalc.years;
      calcMonths = mathCalc.months;
      calcDays = mathCalc.days;
      calcTotalMonths = mathCalc.totalMonths;
    }

    const normalizedSexo = normalizePaiSexo(pacientes.sexo);
    const normalizedGenero = pacientes.genero !== undefined && pacientes.genero !== null && pacientes.genero !== ''
      ? normalizePaiGenero(pacientes.genero)
      : ([1, 2].includes(normalizedSexo) ? normalizedSexo : '');
    const normalizedRegimen = normalizePaiRegimen(pacientes.regimen_afiliacion);
    const normalizedOrientacion = normalizePaiOrientacion(pacientes.orientacion_sexual);
    const normalizedArea = normalizePaiArea(pacientes.area || pacientes.Zona || pacientes.zona);
    const normalizedEsquema = pacientes.esquema_completo ? (normalizePaiSiNo(pacientes.esquema_completo) || pacientes.esquema_completo) : '';

    const existingFechaAtencion = sBasicos ? currentFormData[sBasicos]?.fecha_atencion : null;
    const todayStr = new Date().toISOString().split('T')[0];

    const pMapped = {
      fecha_atencion: existingFechaAtencion || pacientes.fecha_atencion || todayStr,
      num_identificacion: pacientes.numero_identificacion ?? '',
      tipo_identificacion: pacientes.id_tipo_identificacion ?? '',
      primer_nombre: pacientes.primer_nombre ?? '',
      segundo_nombre: pacientes.segundo_nombre ?? '',
      primer_apellido: pacientes.primer_apellido ?? '',
      segundo_apellido: pacientes.segundo_apellido ?? '',
      fecha_nacimiento: pacientes.fecha_nacimiento ? String(pacientes.fecha_nacimiento).split(' ')[0] : '',
      edad_anios: calcYears ?? '',
      edad_meses: calcMonths ?? '',
      edad_dias: calcDays ?? '',
      total_meses: calcTotalMonths ?? '',
      esquema_completo: normalizedEsquema,
      sexo: normalizedSexo,
      genero: normalizedGenero,
      orientacion_sexual: normalizedOrientacion,
      edad_gestacional: pacientes.edad_gestacional ?? '',
      pais_nacimiento: normalizePaiPais(pacientes.pais_nacimiento),
      estatus_migratorio: pacientes.estatus_migratorio ?? '',
      lugar_atencion_parto: pacientes.lugar_atencion_parto ?? '',
      regimen_afiliacion: normalizedRegimen,
      aseguradora: pacientes.aseguradora ?? '',
      pertenencia_etnica: normalizePaiEtnia(pacientes.pertenencia_etnica),
      desplazado: normalizePaiSiNo(pacientes.desplazado),
      discapacitado: normalizePaiSiNo(pacientes.discapacitado),
      fallecido: normalizePaiSiNo(pacientes.fallecido),
      victima_conflicto: normalizePaiSiNo(pacientes.victima_conflicto),
      estudia: normalizePaiSiNo(pacientes.estudia),
      pais_residencia: normalizePaiPais(pacientes.pais_residencia),
      depto_residencia: pacientes.depto_residencia ?? '',
      municipio_residencia: pacientes.municipio_residencia ?? '',
      comuna_localidad: pacientes.comuna_localidad ?? '',
      area: normalizedArea,
      direccion: pacientes.direccion ?? '',
      telefono_fijo: pacientes.telefono_fijo ?? '',
      celular: pacientes.celular ?? '',
      email: pacientes.email ?? '',
      autoriza_llamadas: normalizePaiSiNo(pacientes.autoriza_llamadas),
      autoriza_correo: normalizePaiSiNo(pacientes.autoriza_correo)
    };

    if (sBasicos) updates[sBasicos] = pMapped;
    if (sComp) updates[sComp] = pMapped;
  }

  if (tutores_madre) {
    const mMapped = {
      madre_tipo_id: tutores_madre.id_tipo_identificacion ?? '',
      madre_num_id: tutores_madre.numero_identificacion ?? '',
      madre_primer_nombre: tutores_madre.primer_nombre ?? '',
      madre_segundo_nombre: tutores_madre.segundo_nombre ?? '',
      madre_primer_apellido: tutores_madre.primer_apellido ?? '',
      madre_segundo_apellido: tutores_madre.segundo_apellido ?? '',
      madre_email: tutores_madre.email ?? '',
      madre_tel_fijo: tutores_madre.telefono_fijo ?? '',
      madre_celular: tutores_madre.celular ?? '',
      madre_regimen: normalizePaiRegimen(tutores_madre.regimen_afiliacion) || '',
      madre_etnia: normalizePaiEtnia(tutores_madre.pertenencia_etnica),
      madre_desplazado: normalizePaiSiNo(tutores_madre.desplazado)
    };
    if (sMadre) updates[sMadre] = mMapped;
  }

  if (sEsquema && Array.isArray(vacunas) && vacunas.length > 0) {
    const lastWithCarnet = vacunas.find(v => v.tipo_carnet);
    if (lastWithCarnet?.tipo_carnet) {
      updates[sEsquema] = {
        ...(currentFormData[sEsquema] || {}),
        tipo_carnet: normalizePaiTipoCarnet(lastWithCarnet.tipo_carnet) || lastWithCarnet.tipo_carnet
      };
    }
  }

  return updates;
};

/**
 * Mapea los históricos recibidos de la API para que coincidan con 
 * las columnas de la tabla history en VaccineCard.
 */
export const mapHistoricalData = (resData) => {
  const { tutores_cuidador, historico_antecedentes, antecedentes_medicos, condicion_usuaria, vacunas, observaciones } = resData;

  const tcMapped = (tutores_cuidador || []).map(tc => ({
    ...tc,
    hist_tipo: 'tutores',
    hist_id: tc.id_tutor,
    cuidador_tipo_id: tc.id_tipo_identificacion,
    cuidador_num_id: tc.numero_identificacion,
    cuidador_primer_nombre: tc.primer_nombre,
    cuidador_segundo_nombre: tc.segundo_nombre,
    cuidador_primer_apellido: tc.primer_apellido,
    cuidador_segundo_apellido: tc.segundo_apellido,
    cuidador_parentesco: tc.parentesco,
    cuidador_tel_fijo: tc.telefono_fijo,
    cuidador_email: tc.email,
    cuidador_celular: tc.celular,
    cuidador_desplazado: normalizePaiSiNo(tc.desplazado),
    fechaRegistro: tc.fecha_atencion ? tc.fecha_atencion.split(' ')[0] : '-'
  }));

  const hMapped = (historico_antecedentes || []).map(h => ({
    ...h,
    hist_tipo: 'historico_antecedentes',
    hist_id: h.id_historico,
    fecha_antecedente: h.fecha_registro,
    tipo_antecedente: h.tipo_antecedente,
    descripcion_antecedente: h.descripcion,
    obs_especiales: h.observaciones_especiales,
    fechaRegistro: h.fecha_registro ? h.fecha_registro.split(' ')[0] : '-'
  }));

  const antMapped = (antecedentes_medicos || []).map(a => ({
    ...a,
    hist_tipo: 'antecedentes_medicos',
    hist_id: a.id_antecedente,
    contraindica_vacunacion: normalizePaiSiNo(a.contraindica_vacunacion),
    reaccion_biologicos: normalizePaiSiNo(a.reaccion_biologicos),
    fechaRegistro: a.fecha_registro ? a.fecha_registro.split(' ')[0] : '-'
  }));

  const condMapped = (condicion_usuaria || []).map(c => ({
    ...c,
    hist_tipo: 'condicion_usuaria',
    hist_id: c.id_condicion,
    condicion_usuaria: normalizePaiCondicion(c.condicion_usuaria),
    fechaRegistro: c.fecha_atencion ? c.fecha_atencion.split(' ')[0] : '-'
  }));

  const vacMapped = (vacunas || []).map(v => ({
    ...v,
    hist_tipo: 'esquema_vacunacion',
    hist_id: v.id_esquema_vacunacion,
    tipo_carnet: normalizePaiTipoCarnet(v.tipo_carnet),
    fechaRegistro: v.fecha_aplicacion ? v.fecha_aplicacion.split(' ')[0] : '-'
  }));

  const obsMapped = (observaciones || []).map(o => ({ 
    ...o, 
    hist_tipo: 'registro_observacion',
    hist_id: o.id_registro_obs || o.id_registro_observacion || o.id_registro,
    ingreso_aplicativo: normalizePaiSiNo(o.ingreso_aplicativo_pai || o.ingreso_aplicativo),
    fechaRegistro: o.fecha_aplicacion ? o.fecha_aplicacion.split(' ')[0] : '-' 
  }));

  return {
    ANTECEDENTES: antMapped,
    CONDICION: condMapped,
    HISTORICO: hMapped,
    CUIDADOR: tcMapped,
    VACUNAS: vacMapped,
    OBSERVACIONES: obsMapped
  };
};

/**
 * Construye el payload final para enviar al servidor en storeRegistro.
 */
export const preparePaiPayload = (formData, selectedVaccines, paiData, patientDataSections, registroObservacion, idSede) => {
  const getSectionData = (keyword) => {
    const section = patientDataSections.find(s => {
      const normalized = s.name.toUpperCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      const normKey = keyword.toUpperCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      return normalized.includes(normKey);
    });
    return section ? (formData[section.id] || {}) : {};
  };

  const datosBasicos = getSectionData('BÁSICOS');
  const datosComplementarios = getSectionData('COMPLEMENTARIOS');
  const datosEsquema = getSectionData('ESQUEMA');

  const combinedPatientInfo = {
    ...datosBasicos,
    ...datosComplementarios
  };
  const condicionBloqueada = isCondicionUsuariaBlocked(combinedPatientInfo);
  const globalTipoCarnet = datosEsquema['tipo_carnet'] || combinedPatientInfo['tipo_carnet'] || null;

  const pacientes = {
    ...combinedPatientInfo,
    esquema_completo: datosEsquema['esquema_completo'] || datosBasicos['esquema_completo'] || null
  };

  const esquema_vacunacion = [];
  selectedVaccines.forEach(vaccineId => {
    const vacData = formData[vaccineId];
    if (vacData) {
      const config = paiData.find(v => v.id === vaccineId);
      if (config) {
        esquema_vacunacion.push({
          consecutivo_orden_id: config.consecutivo_id || null,
          vacuna_nombre: config.name,
          ...vacData,
          tipo_carnet: vacData.tipo_carnet || globalTipoCarnet
        });
      }
    }
  });

  return {
    id_sede: idSede,
    pacientes: pacientes,
    antecedentes_medicos: getSectionData('ANTECEDENTES'),
    condicion_usuaria: condicionBloqueada ? {} : getSectionData('CONDICION'),
    historico_antecedentes: getSectionData('HISTORICO'),
    tutores_madre: getSectionData('MADRE'),
    tutores_cuidador: getSectionData('CUIDADOR'),
    registro_observacion: registroObservacion,
    esquema_vacunacion: esquema_vacunacion
  };
};
